import {LocalStyleSheet} from '../../../utils/types'
import {Color} from '../../../style/custom/colors'

export const styles: LocalStyleSheet = {
    wrapper: {
        display: 'flex',
        width: '100%',
        padding: 5
    },
    codeContainer: {
        display: 'flex',
        maxWidth: '124px',
        backgroundColor: Color.neutral2,
        alignSelf: 'center',
        justifyContent: 'center'
    },
    name: {
        // flex: 1,
        alignSelf: 'center',
        paddingLeft: '3%'
    },
    icon: {
        color: Color.neutral2,
        fontSize: '110%',
        alignSelf: 'center',
        cursor: 'pointer'
    },
    diagnosisGrid: {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr 1fr 1fr auto',
        width: '100%',
        columnGap: '12px',
        rowGap: '8px'
    },
    entryHead: {
        color: Color.neutral2,
        //flex: 1,
        fontSize: 12,
        alignSelf: 'center',
        paddingLeft: '3%'
    }
}
